const getAvatarInitials = (name: string, characterCount?: number): string =>
  characterCount === undefined
    ? name.trim()[0].toUpperCase()
    : Array.from(name.trim().normalize('NFC').toUpperCase()).slice(0, characterCount).join('');

export default getAvatarInitials;
